// extracted by mini-css-extract-plugin
module.exports = {"hidden":"closeButton_hidden__6wEua","textEmphasis":"closeButton_textEmphasis__jWEtE","btnClose":"closeButton_btnClose__xAozc"};